import { React, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SimulationDocumentLine } from "./SimulationDocumentLine.js";
import { InterviewService } from "../../../../services/InterviewService";

export function SimulationDocuments({
  candidateEmail,
  interviewId,
  fromUrl,
  fullName
}) {
  const { t } = useTranslation();
  const [simulationDocuments, setSimulationDocuments] = useState([]);
  const [risesimulationDocuments, setRiseSimulationDocuments] = useState([]);
  const [isAccordionCollapsed, setIsAccordionCollapsed] = useState(true);

  useEffect(() => {
    if (candidateEmail !== undefined) {
      InterviewService.getSimulation(candidateEmail).then((data) => {
        /*if (data.corpSimulations.simulationListData.length > 0) {
          setSimulationDocuments(data.corpSimulations.simulationListData);
        } else {
          setSimulationDocuments([]);
        }*/

        if (data.riseSimulations.length > 0) {
          setRiseSimulationDocuments(
            data.riseSimulations.map((item) => {
              return {
                simulationHash: item.id,
                simulationType: item.contractType,
                ctiExtendedValue: item.grossSalary,
                c2K: item.c2K,
                createdOn: item.createdOn,
                owner: item.ownerEmail
              };
            })
          );
        } else {
          setRiseSimulationDocuments([]);
        }
      });
    }
  }, []);

  return (
    <>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingCvs">
          <button
            className={`accordion-button ${
              isAccordionCollapsed ? "collapsed" : ""
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={() => setIsAccordionCollapsed(!isAccordionCollapsed)}
          >
            {t("Simulation")}
          </button>
        </h2>
        <div
          id="collapseCvs"
          className={`accordion-collapse ${
            isAccordionCollapsed ? "collapse" : ""
          }`}
          aria-labelledby="headingCvs"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div class="accordion-body table-wrap margim-table-documents">
            <table className="table mt-2">
              <thead>
                <th>{t("Contract Type")}</th>
                <th>{t("Gross Salary")}</th>
                <th>{t("C2K")}</th>
                <th>{t("Created on")}</th>
                <th>{t("Owner")}</th>
              </thead>
              <tbody>
                <SimulationDocumentLine
                  simulations={simulationDocuments}
                  interviewId={interviewId}
                  fromUrl={fromUrl}
                  fullName={fullName}
                  isRise={false}
                />
                <SimulationDocumentLine
                  simulations={risesimulationDocuments}
                  interviewId={interviewId}
                  fromUrl={fromUrl}
                  fullName={fullName}
                  isRise={true}
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
